import Error from '../../error/components/Error';

import activationErrorSvg from '../../../assets/images/ActivationError.svg';

export const activationLinkAlreadyUsed = {
  firstLevel: () => <Error
    image={activationErrorSvg}
    meta={{
      description: 'client_thisLinkHasBeenUsed',
      keywords:    'default_meta_keywords',
      title:       'client_thisLinkHasBeenUsed_steelline',
    }}
    title={'client_thisLinkHasBeenUsed'}
  />,
};